// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { UploadTokens } from './type';

const uploadTokens: UploadTokens = {
  uploadResultPaddingX1: 'Spacing-12',
  uploadResultPaddingX2: 'Spacing-8',
  uploadResultPaddingY: 'Spacing-5',
  uploadResultBackgroundColor: 'Neutral-fill-2',
  uploadResultGap: 'Spacing-4',
  uploadResultMarginY: 'Spacing-8',
  uploadResultIconSize: 'Size-7',
  uploadResultIconColor: 'Neutral-text-5',
  uploadResultIconHoverBackgroundColor: 'Neutral-fill-3',
  uploadResultIconHoverColor: 'Brand-6',
  uploadResultFontSize: 'Font-14',
  uploadResultFontColor: 'Neutral-text-5',
  uploadResultBorderRadius: 'Radius-default',
  uploadResultErrorFontColor: 'Danger-6',
  uploadResultErrorIconColor: 'Danger-6',
  uploadResultSuccessIconColor: 'Success-6',
  uploadResultDeletedFontColor: 'Neutral-text-3',
  uploadResultUploadingIconColor: 'Brand-6',
  uploadImageBorderRadius: 'Radius-default',
  uploadImageHandlerBorderColor: 'Neutral-border-2',
  uploadImageHandlerBackgroundColor: 'Neutral-fill-1',
  uploadImageHandlerFontColor: 'Neutral-text-4',
  uploadImageHandlerHoverBorderColor: 'Brand-5',
  uploadImageHandlerHoverFontColor: 'Brand-5',
  uploadImageHandlerActiveBorderColor: 'Brand-7',
  uploadImageHandlerActiveFontColor: 'Brand-7',
  uploadImageHandlerErrorBorderColor: 'Danger-6',
  uploadImageHandlerErrorFontColor: 'Danger-6',
  uploadImageHandlerDisabledBorderColor: 'Neutral-border-2',
  uploadImageHandlerDisabledBackgroundColor: 'Neutral-fill-2',
  uploadImageHandlerDisabledFontColor: 'Neutral-text-2',
  uploadImageHandlerIconColor: 'Neutral-text-3',
  uploadImageResultBorderColor: 'Neutral-border-1',
  uploadImageResultBtnSize: 'Size-7',
  uploadImageResultBtnCloseColor: 'Danger-6',
  uploadImageResultBtnRecoverColor: 'Neutral-text-4',
  uploadImageResultMaskBackgroundColor: 'Mask-fill-1',
  uploadImageResultMaskIconSize: 'Size-8',
  uploadImageResultMaskIconColor: 'Neutral-text-1',
  uploadImageResultErrorBorderColor: 'Danger-6',
  uploadImageResultErrorFontColor: 'Danger-6',
  uploadImageResultTipBackgroundColor: 'Neutral-fill-1',
  uploadImageResultTipFontSize: 'Font-12',
  uploadFontSize: 'Font-14',
};

export default uploadTokens;
